/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 5/9/13
 * Time: 2:21 PM
 * To change this template use File | Settings | File Templates.
 *
 * the title view (in the top of the component)
 */
define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var Logger = require('logger');
    var template = require('ui/single-select/templates/singleSelectTitle.tmpl');

    var SingleSelectTitleView = Marionette.ItemView.extend({
        template:template,

        ui:{
            title: ".caption"
        },

        initialize:function (options) {
            this.logger = Logger.getLogger('SingleSelect');

        },

        onRender:function () {

        }

    });

    return SingleSelectTitleView;
});

